import React from "react"
import { Grid } from "@mui/material";
import RecipeCard from "./RecipeCard";

const RecipeIndex = (props) => {
    const { recipes } = props

    return (
        <Grid spacing={2} container>
            {recipes.map((recipe) => (
                <Grid item xs={12} sm={6} md={4} key={recipe.id}>
                    <RecipeCard title={recipe.title} id={recipe.id}/>
                </Grid>
            ))}
        </Grid>
    );
}

export default RecipeIndex
